import { formatDistanceToNow } from 'date-fns';
import { downloadSwap } from '../api';
import ReactGA from 'react-ga4';

/**
 *
 * @param classes
 */
export function classNames(...classes: (string | boolean | undefined)[]): string {
  return classes.filter(Boolean).join(' ');
}

export const formatTimeRemaining = (ms: number): string => {
  const minutes = Math.floor(ms / 60000);
  if (minutes > 60) {
    return `${Math.floor(minutes / 60)}h ${minutes % 60}m`;
  }
  return `${minutes}m`;
};


 /**
 * Takes a date string and returns the relative time from the current date.
 *
 * @param dateString - The date string to be converted to relative time.
 * @returns A string representing the relative time from now.
 */
export function timeAgo(dateString: string): string | null {
  try{
    const date = new Date(dateString);
    return formatDistanceToNow(date, { addSuffix: true });
  } catch (error) {
   return null;
  }
}

export const handleDownloadSwap = async (swapId: string | null) => {
  if (!swapId) {
    alert('Please provide a swap ID');
    return;
  }

  const isProd = import.meta.env.PROD;
  if (isProd) {
    ReactGA.event({
      category: "Face Swap",
      action: "Download",
    });
  }

  try {
    // Fetch the signed download URL (assuming `downloadSwap` returns the signed URL)
    const downloadUrl = await downloadSwap(swapId);

    // Extract file name from headers or use a default one
    const response = await fetch(downloadUrl, { method: 'HEAD' });
    const fileName = response.headers
      .get('Content-Disposition')
      ?.match(/filename="(.+)"/)?.[1] || `swap-file-${swapId}`;

    // Mobile-specific logic: Use native share sheet if available
    if (navigator.share && /Mobi|Android/i.test(navigator.userAgent)) {
      // Use the Blob method for native sharing
      const fileResponse = await fetch(downloadUrl);
      const blob = await fileResponse.blob();
      const file = new File([blob], fileName, { type: blob.type });
      await navigator.share({
        title: 'Download File',
        files: [file],
      });
    } else {
      // Directly trigger download for desktop users
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = fileName;
      link.click();
    }
  } catch (error) {
    console.error('Download failed:', error);
    alert('Failed to download file. Please try again.');
  }
};

/**
 * Simulates a network request by introducing a delay.
 * @param delay - The delay in milliseconds.
 * @returns A promise that resolves after the specified delay.
 */
export function sleep(delay: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log(`Simulated network request completed after ${delay}ms`);
      resolve();
    }, delay);
  });
}